import { z } from 'zod';

import { getSkusDuplicateMessage, VALIDATION_MESSAGES } from '~/constants/equipment';

export const microInverterSchema = z.object({
  brand: z.string({
    invalid_type_error: VALIDATION_MESSAGES.BRAND_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.BRAND_REQUIRED,
  })
    .trim()
    .min(1, VALIDATION_MESSAGES.BRAND_REQUIRED)
    .max(100, VALIDATION_MESSAGES.BRAND_MAX_LENGTH),

  countKey: z.number({
    invalid_type_error: VALIDATION_MESSAGES.COUNT_KEY_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.COUNT_KEY_REQUIRED,
  })
    .min(1, VALIDATION_MESSAGES.COUNT_KEY_MIN),

  is_combo_conecte: z.boolean({
    invalid_type_error: VALIDATION_MESSAGES.STATUS_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.STATUS_REQUIRED,
  }),

  is_enabled: z.boolean({
    invalid_type_error: VALIDATION_MESSAGES.STATUS_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.STATUS_REQUIRED,
  }),

  isHybrid: z.boolean({
    invalid_type_error: VALIDATION_MESSAGES.TYPE_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.TYPE_REQUIRED,
  }),

  model: z.string({
    invalid_type_error: VALIDATION_MESSAGES.MODEL_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.MODEL_REQUIRED,
  })
    .trim()
    .min(1, VALIDATION_MESSAGES.MODEL_REQUIRED)
    .max(100, VALIDATION_MESSAGES.MODEL_MAX_LENGTH),

  overload: z.number({
    invalid_type_error: VALIDATION_MESSAGES.OVERLOAD_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.OVERLOAD_REQUIRED,
  })
    .min(0.1, VALIDATION_MESSAGES.OVERLOAD_MIN)
    .max(5, VALIDATION_MESSAGES.OVERLOAD_MAX),

  phaseId: z.number({
    invalid_type_error: VALIDATION_MESSAGES.PHASE_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.PHASE_REQUIRED,
  })
    .min(1, VALIDATION_MESSAGES.PHASE_RANGE)
    .max(3, VALIDATION_MESSAGES.PHASE_RANGE),

  power: z.number({
    invalid_type_error: VALIDATION_MESSAGES.POWER_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.POWER_REQUIRED,
  })
    .min(0.1, VALIDATION_MESSAGES.POWER_MIN)
    .max(999, VALIDATION_MESSAGES.POWER_MAX),

  tension: z.number({
    invalid_type_error: VALIDATION_MESSAGES.TENSION_INVALID_TYPE,
    required_error: VALIDATION_MESSAGES.TENSION_REQUIRED,
  })
    .min(1, VALIDATION_MESSAGES.TENSION_MIN),

  skus: z.array(z.string().trim().min(1)).nullable().optional()
    .refine(
      (value) => {
        if (!value?.length) return true;
        return new Set(value).size === value.length;
      },
      (value) => {
        const duplicate = value?.find((sku, index) => value.indexOf(sku) !== index);
        return { message: duplicate ? getSkusDuplicateMessage(duplicate) : '' };
      },
    ),
});

export type MicroInverterFormData = z.infer<typeof microInverterSchema>;
